var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 抱歉 该用户未审核通过，请审核通过后再登录 ")])}
var staticRenderFns = []

export { render, staticRenderFns }